import React from 'react';
import { Box, Text, Link, VStack, Flex } from '@chakra-ui/react';
import { defaultFontFamily } from 'src/utils/dynamicFonts';

const PreviewMessage = (): JSX.Element => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      px={4}
      py={8}
      bg="gray.50"
    >
      <Box
        maxWidth="500px"
        bg="white"
        borderRadius="2xl"
        boxShadow="2xl"
        border="1px solid"
        borderColor="gray.100"
        overflow="hidden"
        w="full"
      >
        {/* Header with gradient background */}
        <Box
          bgGradient="linear(135deg, lomaGreen.400, lomaGreen.800)"
          px={8}
          py={12}
          textAlign="center"
        >
          <VStack spacing={4}>
            <Box
              bg="whiteAlpha.200"
              borderRadius="full"
              backdropFilter="blur(10px)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              w="80px"
              h="80px"
            >
              <Text fontSize="4xl" role="img" aria-label="rocket">
                🚀
              </Text>
            </Box>
            <VStack spacing={2}>
              <Text
                fontSize="3xl"
                fontWeight="bold"
                color="white"
                textAlign="center"
                fontFamily={defaultFontFamily}
              >
                Something Great is Coming
              </Text>
              <Text
                fontSize="lg"
                color="whiteAlpha.900"
                textAlign="center"
                maxW="400px"
                lineHeight="1.6"
                fontFamily={defaultFontFamily}
              >
                We&apos;re putting the finishing touches on this site. Stay tuned!
              </Text>
            </VStack>
          </VStack>
        </Box>

        {/* Body content */}
        <Box px={8} py={8}>
          <VStack spacing={6}>
            <Box
              bg="green.50"
              borderRadius="lg"
              p={6}
              border="1px solid"
              borderColor="green.100"
              w="full"
              textAlign="center"
            >
              <Text
                fontSize="md"
                color="lomaGreen.900"
                fontWeight="medium"
                lineHeight="1.6"
                fontFamily={defaultFontFamily}
              >
                ✨ This site is currently in preview mode while we make final preparations for
                launch.
              </Text>
            </Box>

            <Box pt={2} borderTop="1px solid" borderColor="gray.100" w="full" textAlign="center">
              <Flex align="center" justify="center" gap={2}>
                <Text fontSize="sm" color="gray.500" fontFamily={defaultFontFamily}>
                  Site owner?
                </Text>
                <Link
                  href="/login"
                  color="lomaGreen.900"
                  fontWeight="semibold"
                  fontSize="sm"
                  fontFamily={defaultFontFamily}
                  _hover={{
                    textDecoration: 'none',
                  }}
                  transition="all 0.2s"
                  px={3}
                  py={1}
                >
                  Log in here
                </Link>
              </Flex>
            </Box>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewMessage;
